import React, { useCallback, useMemo } from 'react';
import pt from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import lookupActions from 'actions/lookup';

import { Field } from 'components/form';
import { localeOptions } from 'utils/geo';

const LOOKUP_LIMIT = 25;

const LANGUAGE_OPTIONS = localeOptions.filter(
  (option) => !option.value.includes('-'),
);

function toRecord(option) {
  return { id: option.value, code: option.value, name: option.label };
}

function startsWith(option, search) {
  return (
    option.label.toLowerCase().startsWith(search) ||
    option.value.toLowerCase().startsWith(search)
  );
}

export default function PartnerLocales({ defaultValue }) {
  const dispatch = useDispatch();
  const lookup = useSelector((state) => state.lookup);

  const value = useMemo(
    () =>
      defaultValue?.length
        ? defaultValue.map((locale) => ({
            ...locale,
            id: locale.id || locale.code,
          }))
        : undefined,
    [defaultValue],
  );

  const onQuery = useCallback(
    (query) => {
      const search = (query || '').trim().toLowerCase();
      const matched = search
        ? LANGUAGE_OPTIONS.filter((option) => startsWith(option, search))
        : LANGUAGE_OPTIONS;

      dispatch(
        lookupActions.results(matched.slice(0, LOOKUP_LIMIT).map(toRecord)),
      );
    },
    [dispatch],
  );

  return (
    <Field
      type="lookup"
      name="partner.languages"
      label="Languages"
      placeholder="Search languages by name"
      className="span4"
      multiple={true}
      lookup={lookup}
      defaultValue={value}
      onQuery={onQuery}
      queryFocus={true}
      hint="Select every language your team works in"
    />
  );
}

PartnerLocales.propTypes = {
  defaultValue: pt.array,
};
